<template>
  <CFooter :fixed="false">   
    <div fluid class="mr-auto ml-auto">
      <div class="center">     
      <span class="mr-1 " >Desenvolvido pela Subsecretaria de Comunicação da</span> 
      <a href="https://www.timoteo.mg.gov.br" target="_blank">Prefeitura de Timóteo</a>
      <span class="ml-1 mr-1 ">&copy; {{new Date().getFullYear()}} Todos os direitos reservados.</span>
      
      </div>     
      
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped>
.center {
    margin: auto;
    width: 100%;    
    padding: 10px;
}

</style>
